/**
 * Compute the effective (most reliable) duration in seconds for a call,
 * combining 3 possible sources:
 *   1. calls.duration_seconds (Daily.co webhook — sometimes captures only
 *      the closing window of a session and is dramatically subestimated)
 *   2. call.recordings[*].duration_seconds (recording metadata)
 *   3. meetings.duration_minutes * 60 (the source of truth for video meetings,
 *      indexed by daily_recording_id and/or daily_room_url)
 *
 * Returns the MAX of all available sources. Never decreases an existing value.
 */
export function getEffectiveCallDuration(
  call: { duration_seconds?: number | null; recordings?: Array<{ duration_seconds?: number | null }>; metadata?: any; meeting_url?: string | null },
  videoMeetingDurations?: Map<string, number>,
): number {
  const callDuration = call?.duration_seconds || 0;

  const maxRecDuration =
    call?.recordings?.reduce(
      (max: number, r: any) => Math.max(max, r?.duration_seconds || 0),
      0,
    ) || 0;

  let meetingDuration = 0;
  if (videoMeetingDurations && videoMeetingDurations.size > 0) {
    const dailyRecId = call?.metadata?.daily_recording_id;
    const meetingUrl = call?.meeting_url;
    if (dailyRecId && videoMeetingDurations.has(`rec:${dailyRecId}`)) {
      meetingDuration = videoMeetingDurations.get(`rec:${dailyRecId}`) || 0;
    } else if (meetingUrl && videoMeetingDurations.has(`url:${meetingUrl}`)) {
      meetingDuration = videoMeetingDurations.get(`url:${meetingUrl}`) || 0;
    }
  }

  return Math.max(callDuration, maxRecDuration, meetingDuration);
}
